import { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const usePreviousPath = () => {
  const location = useLocation()
  const previousPathRef = useRef(null)

  useEffect(() => {
    previousPathRef.current = location.pathname
  }, [location])

  return previousPathRef.current
}
